import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { delay, tap } from 'rxjs/operators';
import { DateService } from '@app/base/service/date.service';
import { DatePipe } from '@angular/common';

@Injectable()
export class AuthService {
	isLoggedIn: boolean = false;
	private dateService = new DateService();

	private pipe: DatePipe = new DatePipe('pt-BR');
    private now = Date.now();

	// store the URL so we can redirect after logging in
	redirectUrl: string;

	login(): Observable<boolean> {
		return of(true)
			.pipe(
				delay(1000),
				tap((val) => this.isLoggedIn = true),
			)

	}

	logout(): void {
		this.isLoggedIn = false;
	}

	getActiveToken() {
		let today: Date = new Date();
		let tokenExpires: any;

		if (localStorage.getItem('loginToken')) {

			tokenExpires = new Date(JSON.parse(localStorage.getItem('loginToken'))['.expires']);

			if ( tokenExpires !== null && today <= tokenExpires ) {
				return true;
			} else {
				return false;
			}

		} else {
			tokenExpires = null;
			return false;
		}
	}
}
